<template>
  <v-card flat class="ml-4 mr-4">
    <v-card-title
      class="grey--text text--darken-2 font-weight-bold list_title headline pb-1 mb-2"
    >
      Reports for {{ unit.name }}
    </v-card-title>

    <v-row>
      <!-- SELECT REPORT TYPE AND DATETIME -->
      <v-col cols="6">
        <v-select
          v-model="reportType"
          :items="reportTypes"
          label="Report Type"
          outlined
          item-text="label"
          item-value="value"
          prepend-inner-icon="mdi-file"
          hide-details="auto"
          :menu-props="{ auto: false, offsetY: true }"
          @change="onReportTypeChange"
        />
      </v-col>
      <v-col
        v-if="reportType !== 'ebpms' && reportType !== 'trailerProfile' && reportType !== 'mileage'"
        cols="6"
      >
        <v-autocomplete
          v-model="timeInterval"
          :items="timeIntervals"
          label="Time Interval"
          outlined
          item-text="label"
          item-value="value"
          prepend-inner-icon="mdi-calendar-clock"
          hide-details="auto"
          :menu-props="{ auto: false, offsetY: true }"
        />
      </v-col>
      <v-col v-if="reportType === 'ebpms'" cols="6">
        <v-dialog
          ref="dialog"
          v-model="dateModal"
          :return-value.sync="reportTimestamp"
          persistent
          width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="reportTimestamp"
              label="Report Date"
              prepend-icon="mdi-calendar"
              readonly
              hide-details="auto"
              outlined
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="reportTimestamp"
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="dateModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialog.save(reportTimestamp)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>

      <template v-if="reportType === 'mileage'">
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <v-dialog
                ref="mileageFromDialog"
                v-model="mileageFromModal"
                :return-value.sync="mileageFromDate"
                persistent
                width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="mileageFromDate"
                    label="From Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="mileageFromDate" scrollable>
                  <v-spacer />
                  <v-btn text color="primary" @click="mileageFromModal = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.mileageFromDialog.save(mileageFromDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="6">
              <v-dialog
                ref="mileageToDialog"
                v-model="mileageToModal"
                :return-value.sync="mileageToDate"
                persistent
                width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="mileageToDate"
                    label="To Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="mileageToDate" :min="mileageFromDate" scrollable>
                  <v-spacer />
                  <v-btn text color="primary" @click="mileageToModal = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.mileageToDialog.save(mileageToDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <report-email-field
            ref="emailField"
            :email.sync="email"
            :active.sync="activeEmail"
          />
        </v-col>
      </template>
      <v-row v-if="timeInterval === 'custom'">
        <v-col cols="6">
          <v-dialog
            ref="initDateDialog"
            v-model="dateRangeModal.initDate"
            :return-value.sync="dateRange.initDate"
            persistent
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="dateRange.initDate"
                :label="$t('actions.startAt')"
                prepend-icon="mdi-calendar"
                readonly
                hide-details="auto"
                outlined
                v-bind="attrs"
                v-on="on"
                @change="initDateChange"
              />
            </template>
            <v-date-picker
              v-model="dateRange.initDate"
              scrollable
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="dateRangeModal.initDate = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="saveInitDate"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="6">
          <v-dialog
            ref="endDateDialog"
            v-model="dateRangeModal.endDate"
            :return-value.sync="dateRange.endDate"
            persistent
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="dateRange.endDate"
                :label="$t('actions.endAt')"
                prepend-icon="mdi-calendar"
                readonly
                hide-details="auto"
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dateRange.endDate"
              :min="dateRange.initDate"
              scrollable
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="dateRangeModal.endDate = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.endDateDialog.save(dateRange.endDate)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col v-if="oldRangeSnackbar" cols="12">
          <div class="warning-message">
            <v-badge
              overlap
              color="red darken-2"
              icon="mdi-exclamation-thick"
            ></v-badge>
            <span class="warning-message">
              Report preparation may take longer for reports older than 180 days.
            </span>
          </div>
        </v-col>
      </v-row>
      <template v-if="reportType === 'emptyRunning'">
        <v-col cols="6">
          <v-switch
            v-model="activePdf"
            :label="$t('generateDialog.activePdf')"
            class="pdf-switch"
            hide-details="auto"
          />
        </v-col>
        <v-col cols="12">
          <report-email-field
            ref="emailField"
            :email.sync="email"
            :active.sync="activeEmail"
          />
        </v-col>
      </template>
    </v-row>
    <v-card-actions class="mt-4">
      <v-spacer />
      <v-btn
        depressed
        color="success"
        :disabled="!validateButton"
        @click="generateReport"
      >
        Generate Report
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dayjs from 'dayjs'
import ReportEmailField from '@/components/newReports/ReportEmailField'
import brakePerformanceRateReport from 'GraphQL/mutations/reports/brakePerformanceRateReport.gql'
import weeklyReport from 'GraphQL/mutations/reports/weeklyReport.gql'
import tripsReport from 'GraphQL/mutations/reports/tripsReport.gql'
import servicesReport from 'GraphQL/mutations/reports/servicesReport.gql'
import faultsReport from 'GraphQL/mutations/reports/faultsReport.gql'
import snapshotReport from 'GraphQL/mutations/reports/snapshotReport.gql'
import geofencesReport from 'GraphQL/mutations/reports/geofencesReport.gql'
import trailerProfileReport from 'GraphQL/mutations/reports/trailerProfileReport.gql'
import mileageExtractReport from 'GraphQL/mutations/reports/mileageExtractReport.gql'
import emptyRunningReport from 'GraphQL/mutations/reports/emptyRunningReport.gql'

export default {
  components: {
    ReportEmailField
  },
  props: {
    unit: {
      type: Object,
      default: () => {}
    },
    sheetOpen: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dateModal: false,
      reportTimestamp: '',
      reportType: 'ebpms',
      timeInterval: '',
      dateRangeModal: {
        initDate: false,
        endDate: false
      },
      dateRange: {
        initDate: '',
        endDate: ''
      },
      oldRangeSnackbar: false,
      email: '',
      activeEmail: false,
      activePdf: false,
      mileageFromDate: '',
      mileageToDate: '',
      mileageFromModal: false,
      mileageToModal: false
    }
  },
  computed: {
    validateButton () {
      if (this.reportType === 'ebpms') {
        return this.reportTimestamp !== '' && this.unit?.id !== ''
      } else if (this.reportType === 'weekly') {
        return this.unit?.id !== '' && this.timeInterval !== ''
      } else if (this.reportType === 'trips') {
        return this.unit?.id !== '' && this.timeInterval !== ''
      } else if (this.reportType === 'mileage') {
        const hasDates = this.mileageFromDate !== '' && this.mileageToDate !== ''
        const datesValid = !this.mileageDateRangeError
        return this.unit?.id !== '' && hasDates && datesValid
      } else if (this.reportType === 'emptyRunning') {
        if (this.timeInterval === 'custom') {
          return this.unit?.id !== '' && this.dateRange.initDate !== '' && this.dateRange.endDate !== ''
        }
        return this.unit?.id !== '' && this.timeInterval !== ''
      }
      return true
    },
    timeIntervals () {
      return [
        {
          label: this.$i18n.t('timeIntervals.lastWeek'),
          value: 'lastWeek'
        },
        {
          label: this.$i18n.t('timeIntervals.thisWeek'),
          value: 'thisWeek'
        },
        {
          label: this.$i18n.t('timeIntervals.custom'),
          value: 'custom'
        }
      ]
    },

    reportTypes () {
      return [
        {
          label: 'Brake Performance Report',
          value: 'ebpms'
        },
        // {
        //   label: 'Weekly Report',
        //   value: 'weekly'
        // },
        {
          label: 'Trips Report',
          value: 'trips'
        },
        {
          label: 'Services Report',
          value: 'services'
        },
        {
          label: 'Faults Report',
          value: 'faults'
        },
        {
          label: 'Snapshot Report',
          value: 'snapshot'
        },
        {
          label: 'Geofence Report',
          value: 'geofences'
        },
        {
          label: 'Vehicle Profile Report',
          value: 'trailerProfile'
        },
        // Not released on production yet; the mileage branches below stay wired up.
        // {
        //   label: 'Mileage Report',
        //   value: 'mileage'
        // },
        {
          label: 'Empty Trailer Distance Report',
          value: 'emptyRunning'
        }
      ]
    },
    mileageDateRangeError () {
      if (!this.mileageFromDate || !this.mileageToDate) return false
      return dayjs(this.mileageFromDate).isAfter(dayjs(this.mileageToDate))
    },
    user () { return this.$store.state.session }
  },
  watch: {
    sheetOpen (value) {
      if (!value) {
        setTimeout(() => {
          this.dateModal = false
          this.reportTimestamp = ''
          this.reportType = 'ebpms'
          this.timeInterval = ''
          this.mileageFromDate = ''
          this.mileageToDate = ''
          this.email = ''
          this.activeEmail = false
          this.activePdf = false
        }, 0)
      }
    },
    dateRange: {
      handler () {
        this.idShowOldRangeSnackbar()
      },
      deep: true
    }
  },
  methods: {
    generateUnitName () {
      return this.unit.name
    },
    onReportTypeChange () {
      this.timeInterval = ''
      this.mileageFromDate = ''
      this.mileageToDate = ''
      this.email = ''
      this.activeEmail = false
      this.activePdf = false
    },
    saveInitDate () {
      this.$refs.initDateDialog.save(this.dateRange.initDate)
      this.initDateChange(this.dateRange.initDate)
    },
    initDateChange (date) {
      if (date) {
        // Validate if initDate is after endDate
        if (dayjs(date).isAfter(dayjs(this.dateRange.endDate))) {
          this.dateRange.endDate = dayjs(date).format('YYYY-MM-DD')
        }
      }
    },
    idShowOldRangeSnackbar () {
      const today = dayjs().startOf('day')
      const fetchStartDate = dayjs(this.dateRange.initDate).startOf('day')

      // Calculate how many days ago the range started
      // .diff(date, unit) calculates: (today - fetchStartDate)
      const daysAgo = today.diff(fetchStartDate, 'day')

      // If the start of your data is more than 180 days in the past
      this.oldRangeSnackbar = daysAgo > 180
    },
    async generateReport () {
      // Email is optional, but if enabled it must be valid. The field
      // surfaces the error (instead of silently blocking) on submit.
      if ((this.reportType === 'mileage' || this.reportType === 'emptyRunning') && !this.$refs.emailField.validate()) return
      let mutation = brakePerformanceRateReport
      let name = 'brakePerformanceRateReport'
      const timestamp = new Date(this.reportTimestamp)
      let unitId = ''
      if (this.reportType === 'ebpms') {
        unitId = this.unit.id
      } else {
        // For on unitIds and check the type is unit or group
        unitId = []
        unitId.push(this.unit.id)
      }
      let variables = {
        apiToken: this.user.apiToken,
        unitId: unitId,
        timestamp: timestamp / 1000
      }

      if (this.activeEmail) {
        variables.email = this.email
      }

      if (this.reportType === 'ebpms') {
        variables.groupsIds = []
      }
      if (this.reportType === 'weekly') {
        mutation = weeklyReport
        name = 'weeklyReport'
        variables.timeInterval = this.timeInterval

        if (this.timeInterval === 'custom') {
          variables.initDate = new Date(this.dateRange.initDate) / 1000
          variables.endDate = new Date(this.dateRange.endDate) / 1000
        }
      }

      if (this.reportType === 'trips') {
        mutation = tripsReport
        name = 'tripsReport'
        variables.timeInterval = this.timeInterval

        if (this.timeInterval === 'custom') {
          variables.initDate = new Date(this.dateRange.initDate) / 1000
          variables.endDate = new Date(this.dateRange.endDate) / 1000
        }
      }

      if (this.reportType === 'services') {
        mutation = servicesReport
        name = 'servicesReport'
        variables.timeInterval = this.timeInterval

        if (this.timeInterval === 'custom') {
          variables.initDate = new Date(this.dateRange.initDate) / 1000
          variables.endDate = new Date(this.dateRange.endDate) / 1000
        }
      }

      if (this.reportType === 'faults') {
        mutation = faultsReport
        name = 'faultsReport'
        variables.timeInterval = this.timeInterval

        if (this.timeInterval === 'custom') {
          variables.initDate = new Date(this.dateRange.initDate) / 1000
          variables.endDate = new Date(this.dateRange.endDate) / 1000
        }
      }

      if (this.reportType === 'snapshot') {
        mutation = snapshotReport
        name = 'snapshotReport'
        variables.timeInterval = this.timeInterval

        if (this.timeInterval === 'custom') {
          variables.initDate = new Date(this.dateRange.initDate) / 1000
          variables.endDate = new Date(this.dateRange.endDate) / 1000
        }
      }

      if (this.reportType === 'geofences') {
        mutation = geofencesReport
        name = 'geofencesReport'
        variables.timeInterval = this.timeInterval

        if (this.timeInterval === 'custom') {
          variables.initDate = new Date(this.dateRange.initDate) / 1000
          variables.endDate = new Date(this.dateRange.endDate) / 1000
        }
      }

      if (this.reportType === 'trailerProfile') {
        mutation = trailerProfileReport
        name = 'trailerProfileReport'
        variables = {
          apiToken: this.user.apiToken,
          data: {
            unitIds: unitId
          }
        }
      }

      if (this.reportType === 'mileage') {
        mutation = mileageExtractReport
        name = 'mileageExtractReport'
        variables = {
          apiToken: this.user.apiToken,
          unitId: [this.unit.id],
          initDate: new Date(this.mileageFromDate) / 1000,
          endDate: new Date(this.mileageToDate) / 1000
        }

        if (this.activeEmail) {
          variables.email = this.email.trim()
        }
      }

      if (this.reportType === 'emptyRunning') {
        mutation = emptyRunningReport
        name = 'emptyRunningReport'
        variables = {
          apiToken: this.user.apiToken,
          unitId: [this.unit.id],
          timeInterval: this.timeInterval,
          convertToPdf: this.activePdf,
          whitelabelUrl: window.location.hostname
        }

        if (this.timeInterval === 'custom') {
          variables.initDate = new Date(this.dateRange.initDate) / 1000
          variables.endDate = new Date(this.dateRange.endDate) / 1000
        }

        if (this.activeEmail) {
          variables.email = this.email.trim()
        }
      }
      this.$store.commit('setLoading', true)

      this.$apollo
        .mutate({
          mutation,
          variables,
          fetchPolicy: 'no-cache'
        })
        .then(response => {
          const { status, errors, result } = response.data[name]

          switch (status) {
            case 'OK':
              // window.open(process.env.NODE_ENV === 'development' ? `http://localhost:8000/public/${result.url}` : `https://integrate.vanguarder.goldenm.dev/static/${result.url}`, '_blank')
              // Add the url to the id for the variables object that need to be passed to the reports list
              this.$store.commit('reports/addReport', {
                ...result,
                unitName: this.generateUnitName(result.units)

              }, { root: true })
              this.$store.commit('toggleSnackbar', {
                message: this.$i18n.t('reports.start.reports'),
                color: 'success'
              })
              break

            case 'NOTFOUND':
              this.$store.commit('toggleSnackbar', {
                message: 'Theres no brake events for the the date selected',
                color: 'orange darken-2'
              })
              break
            case 'UNPROCESSABLE':
              this.$store.commit('toggleSnackbar', {
                message: errors.days,
                color: 'orange darken-2'
              })
              break

            case 'INTERNALERROR':
              this.$store.commit('toggleSnackbar')
              break
          }
        })
        .catch(_ => {
          this.$store.commit('toggleSnackbar')
        }).finally(() => {
          this.$store.commit('setLoading', false)
        })
    }
  }
}
</script>

<style>
.warning-message {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

/* Limit the switch's clickable area to the control + label, not the full column. */
.pdf-switch .v-input__slot {
  width: fit-content;
}
</style>
